import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { PagedListFormStimulusModel } from "../../../../scripts/_generated/PagedListFormStimulusModel";
import { disableElementAndAddSpinner, enableElementAndRemoveSpinner } from "../../../../scripts/jobCompletion";

export default class PagedListFormController extends BaseStimulusModelController<PagedListFormStimulusModel> {
    
    static targets = [
        "form",
        "submit"
    ];

    readonly formTarget!: HTMLFormElement;
    readonly submitTarget!: HTMLButtonElement;

    connect() {
        this.formTarget.addEventListener("turbo:submit-start", _ => {
            disableElementAndAddSpinner($(this.submitTarget));
        });
        this.formTarget.addEventListener("turbo:submit-end", _ => {
            enableElementAndRemoveSpinner($(this.submitTarget));
        });
    }
}